import React from 'react';
import { Animated } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import TrayHoc from '../TrayHoc';
import { TRAY_TYPES } from '../Utils/TrayTypesConstants';

import styles from './TrayWrapper.Styles';

function TrayWrapper({ type, trayAnimationStyles, trayView: TrayView, getTrayRef, ...props }) {
  if (TrayView) {
    return (
      <Animated.View
        style={[styles.TrayWrapperContainer, trayAnimationStyles]}
        pointerEvents="box-none"
        testID={FrameworkTestKeys.trayWrapperAnimatedView}
      >
        <TrayView ref={getTrayRef} {...props} />
      </Animated.View>
    );
  }
  return (
    <Animated.View
      style={[styles.TrayWrapperContainer, trayAnimationStyles]}
      pointerEvents="box-none"
      testID={FrameworkTestKeys.trayWrapperView}
    >
      <TrayHoc ref={getTrayRef} {...props} />
    </Animated.View>
  );
}

TrayWrapper.propTypes = {
  type: PropTypes.oneOf(Object.values(TRAY_TYPES)),
  trayAnimationStyles: ViewPropTypes.style,
  trayView: PropTypes.any,
  getTrayRef: PropTypes.func,
  normalTrayHeight: PropTypes.number,
  expandedTrayHeight: PropTypes.number,
};

export default TrayWrapper;
